import { Switch } from '@thanx/uikit/switch'

import SegmentGroupHeader from './SegmentGroupHeader'
import SegmentGroupRules from './SegmentGroupRules'
import SegmentGroupSeparator from './SegmentGroupSeparator'
import SegmentNestedGroups from './SegmentNestedGroups'
import { SegmentGroup } from './types'

interface SegmentGroupProps {
  group: SegmentGroup
  groupIndex: number
  depth?: number
}

const SegmentGroupComponent = ({
  group,
  groupIndex,
  depth = 0,
}: SegmentGroupProps) => {
  const isExceptGroup = group.operator === 'EXCEPT' || Boolean(group.isNegated)
  const isTopLevel = depth === 0
  const showGroupSeparator = groupIndex > 0 && isTopLevel

  const wrapperClassName =
    depth > 0
      ? 'thanx-ai-segment-visualization__group-wrapper thanx-ai-segment-visualization__group-wrapper--nested'
      : 'thanx-ai-segment-visualization__group-wrapper'

  const groupClassName = isExceptGroup
    ? 'thanx-ai-segment-visualization__group thanx-ai-segment-visualization__group--excluded'
    : 'thanx-ai-segment-visualization__group'

  const hasNestedGroups = Boolean(
    group.nestedGroups && group.nestedGroups.length > 0
  )
  const hasRules = group.rules.length > 0

  return (
    <div className={wrapperClassName}>
      <Switch condition={showGroupSeparator}>
        <SegmentGroupSeparator
          operator={group.operator}
          isExceptGroup={isExceptGroup}
        />
      </Switch>
      <div className={groupClassName}>
        <SegmentGroupHeader
          groupIndex={groupIndex}
          depth={depth}
          isExceptGroup={isExceptGroup}
        />

        <SegmentGroupRules
          rules={group.rules}
          operator={group.operator}
          isExceptGroup={isExceptGroup}
        />

        <Switch condition={hasNestedGroups}>
          <SegmentNestedGroups
            nestedGroups={group.nestedGroups!}
            parentOperator={group.operator}
            parentHasRules={hasRules}
            depth={depth}
          />
        </Switch>
      </div>
    </div>
  )
}

export default SegmentGroupComponent
